import mitt from "mitt";

// Global event bus — replaces Vue 2 $root.$on/$off/$emit pattern
// Exposed as this.$bus in every component via app.config.globalProperties
const emitter = mitt();

export default {
    install(app) {
        app.config.globalProperties.$bus = emitter;
    }
};

export { emitter };
